import moment from 'moment'

/**
 * Gets a medicalDate object {day, month, year}
 * if month is empty it returns the fist day of year
 * and the part is year
 * if day is empty it returns the first day of month
 * and the part in month
 * else it returns the whole date and the part is day
 * @param {Object} medicalDate
 * @returns {Object} Object with the date and the part
 */
export function medicalDateFormatter(medicalDate) {
  let result = null
  let resultPart = null
  if (medicalDate === null) {
    // Maybe redundant, I leave it for
    // other type of response in case of in_the_past
    result = null
    resultPart = null
  } else if (medicalDate.month === '') {
    // result = moment.utc(new Date(medicalDate.year + '-01-01')).local()
    result = medicalDate.year + '-01-01'
    resultPart = 'year'
  } else if (medicalDate.day === '') {
    result = medicalDate.year + '-' + fixDateString(medicalDate.month) + '-01'
    resultPart = 'month'
  } else {
    result =
      medicalDate.year +
      '-' +
      fixDateString(medicalDate.month) +
      '-' +
      fixDateString(medicalDate.day)
    resultPart = 'day'
  }

  return {
    date: result,
    part: resultPart,
  }
}

/**
 * Function that returns the format of the date
 * depending on the part parameter
 * @param {String} part
 * @returns {String}
 */
export function getDateFormat(part, field) {
  const dateParts = field.split('-')
  if (part) {
    if (part === 'year') {
      return dateParts[0]
    } else if (part === 'month') {
      return dateParts[0] + '-' + dateParts[1]
    } else {
      return dateParts[0] + '-' + dateParts[1] + '-' + dateParts[2]
    }
  }

  return dateParts[0] + '-' + dateParts[1] + '-' + dateParts[2]
}

/**
 * Converts a date string to a
 * moment object
 * @param {String} date
 * @returns {Object} A moment object
 */
export function momentDateObject(date) {
  return moment.utc(date).local()
}

/**
 * Checks if the medical date object
 * {day, month, year}  is a valid date
 * @param {Object} medicalDate
 * @returns
 */
export function validateDateResult(medicalDate) {
  const checkDate = moment(
    medicalDate.year +
      '-' +
      (medicalDate.month < 10 ? '0' + medicalDate.month : medicalDate.month) +
      '-' +
      (medicalDate.day < 10 ? '0' + medicalDate.day : medicalDate.day),
    'YYYY-MM-DD',
    true
  )
  return checkDate.isValid()
}

/**
 * Takes a string and a medical date object
 * {day, month, year} and checks if medical date
 * object is the same or after the date string
 * @param {String} startDate
 * @param {Object} medicalDate
 * @returns {Boolean}
 */
export function isSameOrAfterDate(startDate, medicalDate) {
  const monthString = fixDateString(medicalDate.month)
  const dayString = fixDateString(medicalDate.day)

  const dateString = medicalDate.year + '-' + monthString + '-' + dayString

  return moment(dateString).isSameOrAfter(startDate, 'day')
}

/**
 * Takes two date strings in the format of
 * YYYY-MM-DD and checks if the second is
 * before the first
 * @param {String} startDate
 * @param {String} endDate
 * @returns {Boolean}
 */
export function isBeforeDate(startDate, endDate) {
  return moment(endDate).isBefore(startDate, 'day')
}

/**
 * Takes a part of a date string (month or day)
 * and puts leading zero if it is less than 10
 * @param {String} value
 * @returns {String}
 */
function fixDateString(value) {
  if (value === '') {
    return '01'
  } else {
    if (value < 10) {
      return '0' + value
    } else {
      return value
    }
  }
}
